import { Card } from '@/components/ui/card';
import { useEffect, useState, useMemo } from 'react';
import { Button } from '@/components/ui/button';

const FinalCTA = () => {
  // Offer now available for an indefinite period; always show this section

  const [currentLogoIndex, setCurrentLogoIndex] = useState(0);

  const customerLogos = useMemo(() => [{
    name: "Fractal",
    logo: "/lovable-uploads/7d1ccd03-2690-4a11-9f91-d42bb6d5a308.png"
  }, {
    name: "Shiprocket",
    logo: "/lovable-uploads/68024710-3e67-4a2b-866d-21d0cd49b4b0.png"
  }, {
    name: "Sprinto",
    logo: "/lovable-uploads/32334656-9272-41cd-b728-c0ce02ee72f0.png"
  }, {
    name: "StepSecurity",
    logo: "/lovable-uploads/f0e559de-57be-429d-8fc3-fdb35842aa81.png"
  }, {
    name: "Averlon",
    logo: "/lovable-uploads/Averlon.png"
  }, {
    name: "Thoughtworks",
    logo: "/lovable-uploads/thoughtworks-logo.png"
  }], []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentLogoIndex(prev => (prev + 1) % customerLogos.length);
    }, 2000);
    return () => clearInterval(interval);
  }, [customerLogos.length]);

  return (
    <section className="py-16 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto text-center">
          <div className="mb-8">
            <h2 className="text-3xl lg:text-4xl font-bold mb-4">
              Get the Starter plan at ₹149/month
            </h2>
            <p className="text-xl text-white">
              Organise your hiring. Get powerful sourcing + AI to hire with 1/10th the effort.
            </p>
          </div>

          <Card className="p-8 bg-white/10 backdrop-blur border-white/20 mb-8">
            <div className="text-center mb-6">
              <div className="flex justify-center mb-4">
                <div className="w-full max-w-[240px] aspect-square">
                  <img 
                    src="/qr-code.png" 
                    alt="QR Code for payment" 
                    className="w-full h-full object-contain rounded-lg"
                    loading="lazy"
                    width="240"
                    height="240"
                    onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/placeholder.svg'; }}
                  />
                </div>
              </div>
              
              <p className="text-sm text-white mb-4">Click the button below to jump to the payment button</p>
            </div>

            <div className="mb-4 min-h-[60px] flex items-center justify-center">
              <Button
                onClick={() => {
                  const el = document.getElementById('starter-payment');
                  if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
                className="bg-white text-gray-900 hover:bg-white/90"
              >
                Go to payment button
              </Button>
            </div>

            <p className="text-sm text-white">
              Limited time promotional price. Subject to change anytime.
            </p>
          </Card>

          <div className="space-y-4">
            <p className="text-sm text-gray-200">Trusted by leading companies</p>
            <div className="h-16 flex items-center justify-center">
              <div className="transition-opacity duration-300 bg-white rounded-lg px-4 py-2 border border-white/20 flex items-center justify-center w-32 h-12">
                <img 
                  src={customerLogos[currentLogoIndex].logo} 
                  alt={`${customerLogos[currentLogoIndex].name} logo`} 
                  className="h-8 w-auto max-w-full object-contain"
                  loading="lazy"
                  width="120"
                  height="32"
                  onError={(e) => { (e.currentTarget as HTMLImageElement).src = '/placeholder.svg'; }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;


